import { render, staticRenderFns } from "./admin_course_persistance_status.vue?vue&type=template&id=0f051415&"
import script from "./admin_course_persistance_status.vue?vue&type=script&lang=js&"
export * from "./admin_course_persistance_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports